import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Login from './login';
import OTP from './otp';
import VisitorsPage from './AdminVisitorDashboard';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  

  useEffect(() => {
    const checkAuthentication = () => {
      // Only check for protected routes
      if (location.pathname.startsWith('/visitors')) {
        const token = sessionStorage.getItem('token');
        
        if (!token) {
          // No token, redirect to login
          clearAuthData();
          navigate('/visitor');
          setLoading(false);
          return;
        }
        
        // Token exists, allow access
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    
    const clearAuthData = () => {
      localStorage.clear();
      sessionStorage.clear();
    };
    
    checkAuthentication();
  }, [navigate, location.pathname]);

  return (
    <Routes>
       {/* <Route path="/bb" element={<Login />} /> */}
       <Route path='/visitor' element={<Login />} />
       <Route path='/visitor/otp' element={<OTP />} />
       <Route path='/visitors' element = {<VisitorsPage/>}/> 
    </Routes>
  );
}

export default App;
